<template>
  <div class="AgencyDocking main">
    <div class="AgencyDockingContent">
      <!-- 活动框title -->
      <DockingSystemTitle
        :title="'创新机构对接'"
        :moreType="true"
        :underlineType="false"
        :titleCenter="false"
      />

      <div >
        <el-row class="content">
          <el-col :xs="0" :sm="2" class="hidden-only-xs opacity-0">.</el-col>
          <el-col :xs="24" :sm="20">
            <el-row class="nav">
              <el-col :xs="8" :sm="8"><div>投资机构</div></el-col>
              <el-col :xs="8" :sm="4"><div>成立时间</div></el-col>
              <el-col :xs="8" :sm="3"><div>总投资数</div></el-col>
              <el-col class="hidden-xs-only" :sm="3"
                ><div>近三年投资数</div></el-col
              >
              <el-col class="hidden-xs-only" :sm="3"
                ><div>投资偏好</div></el-col
              >
              <el-col class="hidden-xs-only" :sm="3"
                ><div>投资领域</div></el-col
              >
            </el-row>

            <div class="contentUl">
              <el-row
                class="contentLi"
                v-for="(item, index) in list"
                :key="index"
              >
                <el-col :xs="8" :sm="8">
                  <el-row>
                    <el-col class="pt-10" :xs="24" :sm="12">
                      <router-link :to="{ path:'InstitutionalInvestor',query: { id: item.id }} "
                      >
                        <img
                        :src="item.coverurl"
                        alt=""
                      />
                      </router-link>
                      
                    </el-col>
                    <el-col class="pt-20 hidden-xs-only" :sm="12">
                      {{item.title}}
                    </el-col>
                  </el-row>
                </el-col>
                <el-col class="pt-20" :xs="8" :sm="4">{{item.create_time}} </el-col>
                <el-col class="pt-20" :xs="8" :sm="3"> {{item.investnum}} </el-col>
                <el-col class="hidden-xs-only pt-20" :sm="3"> {{item.threeinvestnum}} </el-col>
                <el-col class="hidden-xs-only" :sm="3">
                  {{item.investhobby}}
                </el-col>
                <el-col class="hidden-xs-only" :sm="3">
                  {{item.investterritory}}
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xs="0" :sm="2" class="hidden-only-xs opacity-0">.</el-col>

        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
// import 'element-ui/lib/theme-chalk/display.css';
import DockingSystemTitle from "@/components/DockingSystem/Title/DockingSystemTitle.vue"; //活动框title
export default {
  props: {
    list:Array
  },
  components: {
    DockingSystemTitle,
  },
  data() {
    return {
     
    };
  },
  created: function () {},
  methods: {},
};
</script>

<style scoped>
@media (max-width: 768px) {
  .AgencyDocking .nav{
    padding: 20px 0;
  }
  .AgencyDocking .contentLi{
    padding: 20px 0;
  }
  .AgencyDocking .contentUl > .contentLi:last-child{
    padding-bottom: 15px;
  }
}
.pt-10 {
  padding-top: 10px;
}
.pt-20 {
  padding-top: 20px;
}
.AgencyDocking {
  margin-top: 39px;
  border-radius: 25px;
  background-image: url("../../../../public/static/images/new_bg.png");
  /* background-repeat: no-repeat; */
  position: relative;
}
.AgencyDocking::after {
  content: "";
  background-color: #000;
  opacity: 0.3;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.AgencyDockingContent {
  position: relative;
  z-index: 100;
}
.content {

  color: #fff;
}
.nav {
  text-align: center;
  padding: 38px 0;
}
.contentUl {
  text-align: center;
}
.contentLi {
  text-align: center;
  padding: 49px 0;
  border-bottom: 1px solid #8a8b8c;
}
.contentUl > .contentLi:last-child {
  border-bottom: none;
  padding-bottom: 33px;
}
</style>